/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { NavCardsSimpleSectionItem } from "./section_item";
import { useWebpageSDK } from "cms/components/hooks/use-webpage-sdk";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";

const NavCardsSimpleSection = (props) => {
    
    const webpage_guid = props?.webpage_guid;
    const { token } = useAuth();
    const { component } = useContext(ContentZoneContext);
    const { fetchWebpageChildren } = useWebpageSDK();
    
    const [children, setChildren] = useState(null);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const executeAsync = async () => {
            const response = await fetchWebpageChildren(token, webpage_guid);
            const webpage = response?.webpage;
            const children = webpage?.children;
            const error = response?.error;
            setError(error);
            if (children && children.length > 0) {
                const enhancedChildren = await Promise.all(
                    children.map(async (child) => {
                        try {
                            const childGuid = child?.guid;
                            const banner_image = await SimpliCityAdminSDK.webpage.getWebpageBannerImage(token, childGuid);

                            return {
                                ...child,
                                banner_image: banner_image || null
                            };
                        } catch (error) {
                            return {
                                ...child,
                                banner_image: null
                            };
                        }
                    })
                );

                setChildren(enhancedChildren);
            } else {
                setChildren(children);
            }
        };

        executeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, webpage_guid]);
    
    const hasContent = isArrayNotEmpty(children);
    const noChildrenMessage = "This page currently has no nav cards.";
    
    return (
        <>
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
                message={noChildrenMessage}
            />
            {!error && children &&
                <div className='simplicity-nav-cards-simple-list'>
                    <div className='simplicity-nav-cards-simple-list-body'>
                        {children.map((item, index) => {
                            return (
                                <NavCardsSimpleSectionItem
                                    key={index}
                                    item={item}
                                />
                            );
                        })}
                    </div>
                </div>
            }
            {error && <div className='simplicity-nav-cards-simple-error'>{error?.message}</div>}
        </>
    );
};

export { NavCardsSimpleSection };
